// @ts-nocheck
// Store Custom Code - Lazy-load Application Insights SDK to reduce public.js bundle size (~170KB savings).
// The heavy SDK packages are only loaded when a connectionString is configured.
import type { ITelemetryItem } from "@microsoft/applicationinsights-web";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC, PropsWithChildren, useEffect, useRef } from "react";

export interface AppInsightsProviderProps {}

const AppInsightsProvider: FC<PropsWithChildren<AppInsightsProviderProps>> = ({ children }) => {
    const { connectionString, corsExcludedDomains, roleName } =
        useSettingsCollection().extensionApplicationInsightsSettings || {};
    const initializedRef = useRef(false);

    useEffect(() => {
        if (initializedRef.current || !connectionString) {
            return;
        }
        initializedRef.current = true;

        Promise.all([
            import(/* webpackChunkName: "appInsights" */ "@microsoft/applicationinsights-react-js"),
            import(/* webpackChunkName: "appInsights" */ "@microsoft/applicationinsights-web"),
        ]).then(([reactJsModule, webModule]) => {
            const reactPlugin = new reactJsModule.ReactPlugin();
            const appInsights = new webModule.ApplicationInsights({
                config: {
                    autoTrackPageVisitTime: true,
                    connectionString,
                    correlationHeaderExcludedDomains: corsExcludedDomains,
                    disableAjaxTracking: false,
                    enableAutoRouteTracking: true,
                    enableCorsCorrelation: true,
                    enableResponseHeaderTracking: true,
                    enableRequestHeaderTracking: true,
                    extensions: [reactPlugin as any],
                },
            });

            try {
                appInsights.loadAppInsights();
            } catch (error) {
                console.error(`Application Insights ${error}`); // eslint-disable-line no-console
                return;
            }

            appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
                env.tags = { ...env.tags, "ai.cloud.role": roleName || "" };
            });
        });
    }, [connectionString]);

    return <>{children}</>;
};

export default AppInsightsProvider;
